import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const getVehicles = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/vehicles`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return res.data.data.vehicles
}

export const addVehicle = async data => {
  const token = await getToken()

  const res = await axios.post(
    `${getBFFUrl()}/addVehicle`,
    {
      operator: 'BALSAS',
      data,
    },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}

export const updateVehicle = async data => {
  const token = await getToken()

  const res = await axios.post(
    `${getBFFUrl()}/updateVehicle`,
    {
      operator: 'BALSAS',
      data,
    },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}

export const deleteVehicle = async licensePlate => {
  const token = await getToken()

  await axios.delete(`${getBFFUrl()}/vehicles?licensePlate=${licensePlate}`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return true
}
